import type { FC } from 'react';
import clsx from 'clsx';

import { Icon } from '@trend-dev/ui-libs-icons';

import styles from './styles.module.scss';

interface IProps {
    /** Пользователь включил микрофон */
    isMicEnabled?: boolean;
    /** Пользователь шарит экран */
    isSharing?: boolean;
}

const getIconToRender = (state: IProps) => {
    if (state.isSharing) {
        return {
            className: styles.shareIconClassName,
            icon: <Icon name='Monitor_15' />,
        };
    }

    if (state.isMicEnabled) {
        return {
            className: styles.micIconClassName,
            icon: <Icon name='Mic_15' />,
        };
    }

    return {
        className: styles.muteIconClassName,
        icon: <Icon name='MicOffFilled_15' />,
    };
};

const Icons: FC<IProps> = ({ isMicEnabled, isSharing }) => {
    const icon = getIconToRender({ isMicEnabled, isSharing });

    return <div className={clsx(icon.className, styles.icon)}>{icon.icon}</div>;
};

export default Icons;
